import { render } from "./PageB.vue?vue&type=template&id=1a512404"
import script from "./PageB.vue?vue&type=script&lang=js"
export * from "./PageB.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__